import { render } from "./generateTextAdCard.vue?vue&type=template&id=1dcb940f"
import script from "./generateTextAdCard.vue?vue&type=script&lang=js"
export * from "./generateTextAdCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__